// TODO: Add it to shortbread cookie registry https://sim.amazon.com/issues/VIBE-1313
export const LOCALE_SELECTION = 'user_locale';
